// Campus photo for /colleges/skidmore-college: CC BY 3.0, by Peter Flass, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AZankel_Music_center.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/skidmore-college/; credited under the photo.
const photo = {
    "slug": "skidmore-college",
    "alt": "The Zankel Music Center, a brick and glass concert hall among trees at Skidmore College",
    "src": "/colleges/skidmore-college/campus-1600.webp",
    "srcSmall": "/colleges/skidmore-college/campus-800.webp",
    "srcMid": "/colleges/skidmore-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/skidmore-college/og.jpg",
    "title": "Zankel Music center",
    "author": "Peter Flass",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AZankel_Music_center.jpg",
    "read": "2026-10-02"
};

export default photo;
